import { ShippingCondition } from '@cemex-core/cmx-api/models/shipping-conditions/shipping-condition';
import { createAction, props } from '@ngrx/store';

const setActive = createAction(
  '[MOO/MODAL/Shipping Condition] Set Active Entity',
  props<{ shippingConditionId: number | string }>(),
);

const fetch = createAction(
  '[MOO/MODAL/Shipping Condition] Fetch Start',
);

const fetchSuccess = createAction(
  '[MOO/MODAL/Shipping Condition] Fetch Success',
  props<{ payload: ShippingCondition[] }>(),
);

const fetchFailed = createAction(
  '[MOO/MODAL/Shipping Condition] Fetch failed',
);

const resetShippingConditionState = createAction(
  '[MOO/MODAL/Shipping Condition] Reset State',
);

const ShippingConditionActions = {
  setActive,

  fetch,
  fetchSuccess,
  fetchFailed,

  resetShippingConditionState,
};

export default ShippingConditionActions;
